import React, { PureComponent } from 'react'
import ReactMarkdown from 'react-markdown'

import RenderProduct from './RenderProduct'

export default class RenderCategory extends PureComponent {
  render() {
    const {products, categories, category} = {...this.props}

    if(category.fields) {
      let columns = 'single';

      if(category.fields.columns===false) {
        columns = 'dual';
      }
      return(
        <div className={"subcategory tastingmenu "+columns}>
          {category.fields.title && <h3>{category.fields.title}</h3>}
          {category.fields.description && <ReactMarkdown source={category.fields.description} softBreak="br" />}
          {(category.fields.pdfMenuButtonText && category.fields.pdfMenu) && <a href={category.fields.pdfMenu.fields.file.url} className="btn" target="_blank" rel="noopener noreferrer">{category.fields.pdfMenuButtonText} (PDF)</a>}
          <div className="products">
            {category.fields.children && category.fields.children.map((child) => {
              let product = products.find((p) => {
                return p.sys.id === child.sys.id
              })
              let subcategory = categories.find((p) => {
                return p.sys.id === child.sys.id
              })
              if(product) {
                return(
                  <RenderProduct product={product} hidePrice={category.fields.tastingMenu ? true : false} key={product.sys.id} />
                )
              }

              if(subcategory) {
                let columns = 'single';

                if(subcategory.fields.columns===false) {
                  columns = 'dual';
                }
                return(
                  <div className={"subcategory tastingmenu "+columns} key={subcategory.sys.id}>
                    {subcategory.fields.title && <h3>{subcategory.fields.title}</h3>}
                    {subcategory.fields.description && <ReactMarkdown source={subcategory.fields.description} softBreak="br" />}
                    {(subcategory.fields.pdfMenuButtonText && subcategory.fields.pdfMenu) && <a href={subcategory.fields.pdfMenu.fields.file.url} className="btn" target="_blank" rel="noopener noreferrer">{subcategory.fields.pdfMenuButtonText} (PDF)</a>}
                    <div className="products">
                      {subcategory.fields.children && subcategory.fields.children.map((subchild) => {
                        let subproduct = products.find((p) => {
                          return p.sys.id === subchild.sys.id
                        })
                        if(subproduct) {
                          return(
                            <RenderProduct product={subproduct} hidePrice={subcategory.fields.tastingMenu?true:false} key={subproduct.sys.id} />
                          )
                        }
                        return null;
                      })}
                    </div>
                  </div>
                )
              }
              return null;
            })}
          </div>
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/RenderCategory.js